import { Spin } from 'antd';
import AutoComplete, { AutoCompleteProps } from 'antd/lib/auto-complete';
import { OptionProps } from 'antd/lib/select';
import * as React from 'react';
import { GraphqlQuery } from 'requestapijs';
import { ExpenseNodeConnection, ExpenseNodeEdge } from '../../../schema';

const Option = AutoComplete.Option as React.ClassicComponentClass<CustomOption>;

export class ExpenseDropdown extends React.Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);

    this.state = {
      head: '',
      expense: null,
      touched: false,
    };
  }

  value = (expenses: ExpenseNodeEdge[]) => {
    if (this.state.touched) {
      return this.state.head;
    }

    const expense = expenses.find((v) => v.node?.id === this.props.value);
    if (!expense) return;
    return expense.node?.head;
  };

  render() {
    const { head } = this.state;
    const { value, onSelect, companyId } = this.props;
    return (
      <GraphqlQuery
        queryString={`
          query expenseDropdown($id: ID, $head: String, $companyId: ID) {
            allExpenses(id: $id, head: $head ,companyId: $companyId) {
              edges {
                node {
                  id
                  head
                }
              }
            }
          }
        `}
        variables={{
          head,
          id: value && !head ? value : '',
          companyId,
        }}
        render={(
          response: { allExpenses: ExpenseNodeConnection },
          error,
          loading,
        ) => {
          if (loading) return <Spin />;
          if (error) return <div>{JSON.stringify(error)}</div>;
          if (response) {
            return (
              <div style={{ width: '100%' }}>
                <AutoComplete
                  {...this.props}
                  placeholder="Select Expense"
                  dataSource={response.allExpenses.edges.map((expense) => (
                    <Option
                      key={expense.node?.id}
                      lable={expense.node}
                      expense={expense}
                    >
                      {expense.node?.head}
                    </Option>
                  ))}
                  value={this.value(response.allExpenses.edges)}
                  optionLabelProp="children"
                  style={{ width: '100%' }}
                  onSearch={(expense) =>
                    this.setState({ head: expense, touched: true })
                  }
                  onSelect={(e, f) => {
                    this.setState({
                      head: (f as any).props.expense.node.head,
                      touched: true,
                    });
                    onSelect && onSelect(e, f);
                  }}
                />
              </div>
            );
          }
          return <Spin />;
        }}
      />
    );
  }
}

interface CustomOption extends OptionProps {
  lable?: React.ReactNode;
  display?: string;
  expense?: any;
}

interface Props extends AutoCompleteProps {
  companyId: string;
}

interface State {
  head: string;
  expense: ExpenseNodeEdge | null;
  touched: boolean;
}
